import Repository from '../axios'

const resource = "/admin/supplier/raw_material_carriers";

export default {
  getListOfCarriers() {
    return Repository.get(`${resource}`)
  },
  getCarrier(id) {
    return Repository.get(`${resource}/${id}`)
  },
  createCarrier(payload) {
    return Repository.post(`${resource}`, payload)
  },
  deleteCarrier(id) {
    return Repository.delete(`${resource}/${id}`)
  },
  updateCarrier(id, payload) {
    return Repository.put(`${resource}/${id}`, payload)
  }
};
